/** `2026-10-25T14:30:00` → `25/10/2026 14:30` (só formatação; sem fuso inventado). */
export const formatDataHoraNivel = (iso?: string | null): string => {
  if (!iso) return '—'
  const [y, m, d] = iso.slice(0, 10).split('-')
  const hora = iso.length > 15 ? ` ${iso.slice(11, 16)}` : ''
  return `${d}/${m}/${y}${hora}`
}
